//
// Copyright 2022 DXOS.org
//

// Replacement implementation for the browser (see package.json).

export const subtleCrypto = crypto.subtle;

export const webcrypto = crypto;
